import React from 'react';
import posthogJs from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { createRoot } from 'react-dom/client';
import { clearAuthentication, EvaErrorBoundary } from '@engelvoelkersamericas/common-ui';

import setupAxiosInterceptors from '@configs/axios-interceptor';

import App from './App';

setupAxiosInterceptors(() => clearAuthentication());

const root = createRoot(document.getElementById('root'));

const posthogConfig = {
  apiKey: PROFILE_POSTHOG_API_KEY,
  options: {
    api_host: PROFILE_POSTHOG_HOST,
    // Enable exception autocapture for automatic error tracking
    enableExceptionAutocapture: true,
    // Add custom context to error reports
    errorContext: {
      version: VERSION,
      environment: DEVELOPMENT ? 'development' : 'production',
    },
    debug: DEVELOPMENT,
  },
};

// Initialize PostHog for error tracking if enabled
if (POSTHOG_ENABLED) {
  // Initialize PostHog with the same config we use for the provider
  posthogJs.init(posthogConfig.apiKey, posthogConfig.options);

  // Start session recording for better error context
  posthogJs.startSessionRecording();
}

root.render(
  POSTHOG_ENABLED ? (
    <PostHogProvider client={posthogJs}>
      <EvaErrorBoundary>
        <App />
      </EvaErrorBoundary>
    </PostHogProvider>
  ) : (
    <EvaErrorBoundary>
      <App />
    </EvaErrorBoundary>
  ),
);
